import React, { useState, useEffect } from 'react';
import { LogOut, Globe, ArrowRight, Edit2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AdminNav from '../components/AdminNav';
import { openAccessService, authService } from '../services/api';

function AdminOpenAccess() {
  const navigate = useNavigate();
  const [openAccessId, setOpenAccessId] = useState(null);
  const [content, setContent] = useState('');
  const [tempContent, setTempContent] = useState('');
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchOpenAccess = async () => {
      try {
        const response = await openAccessService.get();
        if (response.data && response.data.id) {
          setOpenAccessId(response.data.id);
          setContent(response.data.content || '');
          setTempContent(response.data.content || '');
        } else {
          setEditing(true);
        }
      } catch (err) {
        setEditing(true);
      } finally {
        setLoading(false);
      }
    };
    fetchOpenAccess();
  }, []);

  const handleLogout = () => {
    authService.logout();
    navigate('/admin-login');
  };

  const handleSave = async () => {
    try {
      if (openAccessId) {
        await openAccessService.update(openAccessId, { content: tempContent });
      } else {
        const response = await openAccessService.create({ content: tempContent });
        setOpenAccessId(response.data.id);
      }
      setContent(tempContent);
      setEditing(false);
      setError('');
    } catch (err) {
      setError('خطا در ذخیره دسترسی آزاد');
    }
  };

  const handleCancel = () => {
    setTempContent(content);
    setEditing(false);
  };

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-4xl font-bold mb-2">مدیریت دسترسی آزاد</h1>
              <p className="text-xl text-blue-100">ویرایش محتوای صفحه دسترسی آزاد</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => navigate('/admin/articles')} className="flex items-center gap-2 px-4 py-2 bg-blue-700 hover:bg-blue-600 rounded-lg font-semibold transition">
                <ArrowRight size={18} />
                بازگشت
              </button>
              <button onClick={handleLogout} className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg font-semibold transition">
                <LogOut size={18} />
                خروج
              </button>
            </div>
          </div>
        </div>
      </div>

      <AdminNav />

      <div className="max-w-7xl mx-auto px-4 py-12">
        {error && <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">{error}</div>}

        <div className="bg-white rounded-xl shadow-md p-8">
          <div className="flex items-center gap-3 mb-6">
            <Globe className="text-blue-700" size={28} />
            <h2 className="text-3xl font-bold text-gray-900">محتوای دسترسی آزاد</h2>
          </div>

          {editing ? (
            <div className="space-y-4">
              <textarea
                value={tempContent}
                onChange={(e) => setTempContent(e.target.value)}
                rows="15"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
              <div className="flex gap-4">
                <button onClick={handleSave} className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg font-bold hover:bg-green-700 transition">ذخیره</button>
                {content !== '' && (
                  <button onClick={handleCancel} className="flex-1 px-6 py-3 bg-gray-300 text-gray-700 rounded-lg font-bold hover:bg-gray-400 transition">انصراف</button>
                )}
              </div>
            </div>
          ) : (
            <div>
              <div className="text-gray-700 leading-relaxed whitespace-pre-wrap mb-6 min-h-[200px]">
                {content || 'اطلاعاتی برای نمایش وجود ندارد'}
              </div>
              <button onClick={() => setEditing(true)} className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-bold hover:bg-blue-700 transition">
                <Edit2 size={18} />
                ویرایش
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminOpenAccess;
